import React from "react";
import { AuthenticatedGuard } from "./lib/AuthenticatedGuard";
import { CreateUser } from "./lib/CreateUser";
import { BankManagerAccount } from "./lib/bank-manager/BankManagerAccount";

interface ProtectedRouteProps {
  component: React.FC;
}

function ProtectedRoute({ component: Component }: ProtectedRouteProps) {
  return <AuthenticatedGuard
    role_claim_json_path="resource_access['osculteo-api'].roles"
    required_roles="user">
    <CreateUser>
      <BankManagerAccount>
        <Component />
      </BankManagerAccount>
    </CreateUser>
  </AuthenticatedGuard>
};

export default ProtectedRoute;
